export default __webpack_public_path__ + "static/media/case.fef879ca.png";